import {Component, OnInit, Input} from "@angular/core";
import {Constants} from "../../services/constants";
import {ProfilesService} from "../../services/profiles.service";
import {TenantService} from "../../services/tenant.service";
import {NavigationEnd} from "@angular/router";
import {UserService} from "../../services/user.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  @Input()
  isHomePage: boolean = false;
  header: any;

  private logo: string = Constants.TENANT_BUCKET() + 'logo.jpg';
  private tenantBucket = Constants.TENANT_BUCKET();
  private categories: any;
  private isHeaderHidden: boolean = true;
  private user: any;

  constructor(private profileService: ProfilesService,
              private userService: UserService,
              private tenantService: TenantService) {
    let self = this;
    this.profileService.subscribeForCategories()
      .subscribe(categories => {
        this.categories = [];
        categories.forEach(function(item) {
          self.categories.push(item);
          item.subCategories.forEach(function(item1) {
            item1.isSubCategory = true;
            self.categories.push(item1);
          })
        })
      });
    this.profileService.getCategories();

    this.tenantService.subscribeForTenant()
      .subscribe(tenant => {
        this.loadDoc();
      });
  }

  loadDoc() {
    let self = this;
    let xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        self.header = xhttp.responseText;
      }
    };
    xhttp.open("GET", this.tenantService.getHeaderUrl(), true);
    xhttp.setRequestHeader("Access-Control-Allow-Origin", "*");
    xhttp.send();
  }

  ngOnInit() {

    this.userService.getCurrentUser()
      .then(user => {
        this.user = user;
      });
    this.userService.handleLoggedOutEvent()
      .subscribe(value => {
        this.user = null;
      });
    this.userService.handleLoggedInEvent()
      .subscribe(user => {
        this.user = user;
      });
    Constants.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        if (event.url == "/reseller") {
          this.isHeaderHidden = true;
        } else {
          this.isHeaderHidden = false;
        }
      }
    });
  }


  searchProfile(text: string) {
    this.profileService.searchProfile(text);
  }


}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts